export default __webpack_public_path__ + "static/media/github-1-yellow.d030f221.svg";